// Reusable documentation blocks about splitting an event. Each block is one self-contained
// paragraph group that can be shown on its own or composed into a doc (see ../docs.js).
// Body item types are described in ../README.md.
export default [
  {
    id: 'split.intro',
    body: [
      { p: 'Splitting divides an event into two halves, A and B. Regular, combined, and conjunction events are split differently.' }
    ]
  },
  {
    id: 'split.availability',
    title: 'When can an event be split?',
    body: [
      { p: 'An event can be split when:' },
      {
        ul: [
          'The draft has **Finalise** status.',
          'The event has **2 rounds**.',
          'It is a top-level event (the original event, not one of its Event 1 / Event 2 child events).',
          'It has not already been split. An event created as a result of a split cannot be split again, and a split event cannot be changed to Combined or Conjunction.',
          'No draws have been generated for the event yet.'
        ]
      },
      { p: 'To split an event, use the split icon in the Events table on the Committee dashboard. A split cannot be undone.' }
    ]
  },
  {
    id: 'split.regular',
    title: 'Regular event',
    body: [
      {
        ul: [
          'The event is divided into **Event A** and **Event B**, both with the same settings and judges.',
          'Declared Prize Money is divided equally between A and B.',
          'Nominations are distributed alternately between the two sides: every second nomination moves to B.',
          'Each half has its own draw.'
        ]
      }
    ]
  },
  {
    id: 'split.combined',
    title: 'Combined event',
    body: [
      {
        ul: [
          'Two independent combined events are created: **Combined A** (Event 1 A + Event 2 A) and **Combined B** (Event 1 B + Event 2 B).',
          'Each side has its own combined first round and two finals. This creates four finals in total: Event 1 A, Event 1 B, Event 2 A, and Event 2 B.',
          'Declared Prize Money is divided equally between A and B.',
          'A combined nomination (Event 1 & 2) always stays together. Both parts are assigned to A or both to B. Nominations are distributed alternately between the two sides.',
          'When adding a nomination through Draws, only options for the current side are available. For example, on side A, the options are Event 1 A, Event 2 A, or Event 1 A + Event 2 A.'
        ]
      }
    ]
  },
  {
    id: 'split.conjunction',
    title: 'Conjunction event',
    body: [
      {
        ul: [
          'The two events are not split into independent combined pairs. Instead, they become **Event 1 A** and **Event 1 B**, with their first rounds run separately.',
          'One shared final is created for Event 2. Only nominations entered into the second event (for example, an Event 1 & 2 nomination) can progress to this final, regardless of whether they were assigned to A or B during the split.',
          'An Event 1 & 2 nomination always stays together on the same side and is never separated.'
        ]
      }
    ]
  },
  {
    id: 'split.after',
    title: 'After the split',
    body: [
      {
        ul: [
          'A secretary can move individual nominations between A and B using **Move To** on the Accepted Nominations area.',
          'An Event 1 & 2 nomination always moves as a whole, and its draw moves with it.',
          'The draw is not recalculated when a nomination is moved. The moved run takes the first available slot on the other side or, if there are no available slots, is placed last.'
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/docs/blocks/split.js